// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loader_ldsRoller__1yZNL"};